import { getRandom, serializeObject, kmMetrics, isBot, isProd } from '@utilities';

import leftSidebarBanners from './images/leftSidebar';
import rightSidebarBanners from './images/rightSidebar';

let lastIndex = null;

export default class RandomBanner {
    constructor(context) {
        this.context = context;

        if (this.context.innerHTML) return;

        const { type, id } = this.context.dataset;
        const banners = {
            leftSidebar: leftSidebarBanners,
            rightSidebar: rightSidebarBanners,
        };

        this.id = id;
        this.url = window.location.href;

        const currentBanners = banners[type];
        if (currentBanners) {
            this.context.style.marginBottom = '10px';

            this.render(currentBanners);
        }
    }

    handleClick = () => {
        if (!isBot() && isProd) {
            kmMetrics({
                id: this.id,
                url: this.url,
                type: 'click',
            });
        }

        this.context.removeEventListener('click', this.handleClick);
    };

    render(array = []) {
        const arrayLength = array.length - 1;
        let randomIndex = getRandom(arrayLength);

        if (randomIndex === lastIndex) {
            randomIndex = getRandom(arrayLength);
        }
        lastIndex = randomIndex;

        const { image, retina, url } = array[randomIndex];
        const linkNode = document.createElement('a');
        const imageNode = document.createElement('img');
        const content = document.querySelector('[data-title="title"]').innerHTML;

        imageNode.src = `${image}`;
        if (retina) {
            imageNode.srcset = `${retina} 2x`;
        }
        imageNode.classList.add('ad-banner');
        imageNode.setAttribute('alt', '');

        const utm = serializeObject({
            utm_source: 'inlink',
            utm_medium: 'banner',
            utm_campaign: window.location.pathname.slice(1).replace(/\/$/, '').replace(/\//g, '-'),
            utm_content: content,
        });

        linkNode.href = `${url}?${utm}`;
        linkNode.appendChild(imageNode);

        this.context.appendChild(linkNode);
        this.context.addEventListener('click', this.handleClick);

        if (!isBot() && isProd) {
            kmMetrics({
                id: this.id,
                url: this.url,
                type: 'show',
            });
        }
    }
}
